export default __webpack_public_path__ + "static/media/icon-TechnicalArticles.b10f8256.svg";